import { Star } from 'lucide-react';

interface RatingProps {
  rating: number;
  count?: number;
  size?: 'sm' | 'md';
}

export const Rating = ({ rating, count, size = 'md' }: RatingProps) => {
  const starSize = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const textSize = size === 'sm' ? 'text-sm' : 'text-base';

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <Star
            key={star}
            className={`${starSize} ${
              star <= rating
                ? 'fill-[#FF6A2A] text-[#FF6A2A]'
                : 'fill-[#E5E7EB] text-[#E5E7EB]'
            }`}
          />
        ))}
      </div>
      {count !== undefined && (
        <span className={`${textSize} text-[#6B7280] font-medium`}>
          ({count})
        </span>
      )}
    </div>
  );
};
